import { useMemo } from 'react';
import { getDragIndicatorsInChart } from '~/modules/resourcing/common/hooks/useResourceAllocationDragIndicators';
import { mapIsoStringtoUtcObject } from '~/modules/common/dates/convert';
import { useMeContext } from '~/modules/me';

export const useSetResourceAllocationRepeatButton = ({
  chartDisplayDateRange,
  resourceAllocation,
  isEditEnabled
}) => {
  const {
    featureFlags: {
      isPsaRmpTaskAllocation1Enabled,
      isPsaRmpSetResourceAllocationEnabled
    }
  } = useMeContext();

  const { endDragIndicator } = useMemo(
    () =>
      getDragIndicatorsInChart({
        chartDisplayDateRange,
        resourceAllocation
      }),
    [chartDisplayDateRange, resourceAllocation]
  );

  const showSetResourceAllocationButton =
    isPsaRmpTaskAllocation1Enabled &&
    isPsaRmpSetResourceAllocationEnabled &&
    isEditEnabled &&
    endDragIndicator;

  const allocationStartDate = useMemo(
    () =>
      resourceAllocation?.endDate
        ? mapIsoStringtoUtcObject(resourceAllocation.endDate).plus({ days: 1 })
        : null,
    [resourceAllocation?.endDate]
  );

  return { showSetResourceAllocationButton, allocationStartDate };
};
